import { updateUserEmailApi } from "@/api/services/main/auth";
import { Button } from "@/components/elements/Button";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { AppRoutes } from "@/routes/config";
import { divider, text } from "@/theme/colors";
import { showError } from "@/utils/error";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

type TConfirmEmailPageProps = {};

export const ConfirmEmailPage: FC<TConfirmEmailPageProps> = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const emailParam = searchParams.get("email");
  const tokenParam = searchParams.get("token");
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    handleUpdateUserEmail().finally(() => setIsLoading(false));
  }, []);

  const handleUpdateUserEmail = async () => {
    try {
      const data = { email: emailParam ?? "", token: tokenParam ?? "" };
      await updateUserEmailApi(data);
    } catch (error) {
      showError(error);
      navigate(AppRoutes.pageNotFound, { replace: true });
    }
  };

  if (isLoading) return <LoadingScreen />;

  return (
    <Stack gap={4} alignItems="center">
      <Stack gap={1} alignItems="center">
        <LoginLogo />
      </Stack>
      <Stack gap={3} pt={2}>
        <Stack pb={1}>
          <Typography variant="head20Bold" color={text.primary} textAlign="center">メールアドレスの変更完了</Typography>
        </Stack>
        <Typography variant="body14" width={400} color={text.secondary}>
          メールアドレスの変更完了いたしました。
        </Typography>
        <Stack>
          <Typography pb={1} borderBottom={`1px solid ${divider.high}`} variant="body14" width={400} color={text.secondary}>
            変更後のメールアドレス
          </Typography>
          <Typography pt={1} variant="body14Bold" width={400}>
            {emailParam}
          </Typography>
        </Stack>
      </Stack>
      <Stack pt={2} width="100%">
        <Button
          variant="primary"
          fullWidth
          onClick={() => {
            navigate(AppRoutes.userSettingDetail);
          }}
        >
          ユーザー設定ページへ
        </Button>
      </Stack>
    </Stack>
  );
};
